import { Count } from './Count'
import { Fact } from './Fact'
import type { MapLane } from './map'
import { FILING_GAP } from './mapLayout'

type Filing = Pick<MapLane, 'statementCount' | 'pageCount'>

export const Filed = ({ filing }: { filing: Filing }) => (
  <Fact label="Filed" className={FILING_GAP}>
    <span>
      <Count value={filing.statementCount} one="statement" many="statements" />
      <span className="text-ink-subtle"> · </span>
      <Count value={filing.pageCount} one="page" many="pages" />
    </span>
  </Fact>
)
